import { EnrollmentApiService } from '../services';
import type { CompleteQuizResponse } from '../services';
import type { QuizAttemptQuestionDto } from '../services';
import type { QuizAttemptDto, CompleteQuizRequest } from '../services';

export const startQuiz = (enrollmentId: string, stepId: string) => {
  return EnrollmentApiService.startQuiz(enrollmentId, stepId);
};
export const completeQuiz = (
  enrollmentId: string,
  stepId: string,
  payload: CompleteQuizPayload
) => {
  return EnrollmentApiService.completeQuiz(enrollmentId, stepId, payload);
};
export const getLastAttempt = (enrollmentId: string, stepId: string) => {
  return EnrollmentApiService.getLastAttempt(enrollmentId, stepId);
};

export type QuizType = QuizAttemptDto;
export type QuizQuestionType = QuizAttemptQuestionDto;
export type CompleteQuizPayload = CompleteQuizRequest;
export type CompleteQuizResult = CompleteQuizResponse;
